import {
  CLAIMED_PATIENT_BY_USER_REQUEST,
  CLAIMED_PATIENT_BY_USER_FAILURE,
  CLAIMED_PATIENT_BY_USER_SUCCESS,
} from '../actions/actionTypes';

const initialState = {
  claimedUser: {},
  isFetchingClaimedUser: false,
  isErrorInClaimedUser: null,
};

const claimedUser = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  } else {
    switch (action.type) {
      case CLAIMED_PATIENT_BY_USER_REQUEST:
        return {
          ...state,
          isFetchingClaimedUser: true,
          isErrorInClaimedUser: null,
        };
      case CLAIMED_PATIENT_BY_USER_SUCCESS:
        return {
          ...state,
          isFetchingClaimedUser: false,
          claimedUser: action.payload,
          isErrorInClaimedUser: null,
        };
      case CLAIMED_PATIENT_BY_USER_FAILURE:
        return {
          ...state,
          isFetchingClaimedUser: false,
          isErrorInClaimedUser: 'SomeThing went wrong.',
        };
      default:
        return state;
    }
  }
};

export default claimedUser;
